import { useState } from 'react';
import mainservice from '../../services/MainService';
import { State } from './PlaningToolRoot';
import PersonList from './Person/PersonList';
import { PersonKind } from './Person/PersonKind';
import EventList from './Event/EventList';
import CustomerList from './Customer/CustomerList';
import CustomerLocationList from './CustomerLocation/CustomerLocationList';
import LocationList from './Location/LocationList';
import MaterialView from './materialView';
import { MaterialItemDTO } from '../DTO/MaterialItemDTO';
import { DisplayMode } from './day/dayView';
import { ObjectKind } from '../models/objectKinds';
import { X } from 'react-feather';
import { PublishKind } from '../models/publishKinds';

export enum RightDrawerContent {
  nothing,
  selectPerson,
  selectTrainer,
  selectEvent,
  selectEventForLocation,
  selectEventForCustomer,
  selectSeminar,
  selectCustomer,
  selectCustomerLocation,
  selectLocation,
  editMaterial,
  viewMaterial,
}

export function RightDrawer(props: {
  changeOpenState: (newState: State) => void,
  children?: React.ReactElement | (React.ReactElement | null | false)[],
  standardState?: State,
}) {
  const [contentType, setContentType] = useState(RightDrawerContent.nothing)
  const [id, setId] = useState(-1)
  const [broadCastBackKey, setBroadCastBackKey] = useState('broadCastBackKey')
  const [materialItem] = useState(new MaterialItemDTO({id: -1}))
  mainservice.registerToBroadcast(
    'RightDrawer',
    (key: string, _value: any) => {
      if (key !== 'rightDrawerOpen') { return }
      console.log('RightDrawer', _value)
      if (_value.broadCastBackKey) { setBroadCastBackKey(_value.broadCastBackKey as string) }
      if (_value.contentType === RightDrawerContent.editMaterial) {
        setId(_value.id)
      }
      if (_value.contentType === RightDrawerContent.viewMaterial) {
        setId(_value.id)
      }
      setContentType(_value.contentType as RightDrawerContent)
      props.changeOpenState(State.open)
    }
  )
  function showContent() {
    if (contentType === RightDrawerContent.selectTrainer) {
      return <PersonList
        key={'personListSelectTrainer'}
        className='w3-margin-top scrollContent'
        selected={-1}
        headline={'Trainer'}
        onSelected={async (personIds: number[]) => {
          mainservice.broadcast(broadCastBackKey, {
            personIds: personIds,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        personKind={PersonKind.trainer}
        compact={'medium'}
        noCount
        noMail
      />
    }
    if (contentType === RightDrawerContent.selectPerson) {
      return <PersonList
        key={'personListSelectGeneric'}
        className='w3-margin-top scrollContent'
        selected={-1}
        headline={'Personen'}
        onSelected={async (personIds: number[]) => {
          mainservice.broadcast(broadCastBackKey, {
            personIds: personIds,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        personKind={PersonKind.generic}
        compact={'medium'}
        noCount
        noMail
      />
    }

    if (contentType === RightDrawerContent.selectEvent) {
      return <EventList
        className='w3-margin-top'
        headline={'Veranstaltung wählen'}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        objectKind={ObjectKind.event}
        publishKind={PublishKind.isSeminar}
        compact={'yes'}
//         ignoreDate='ignore'
        minDateFilter={true}
        // sort='desc_date'
      />
    }
    if (contentType === RightDrawerContent.selectEventForCustomer) {
      return <EventList
        className='w3-margin-top'
        headline={'Veranstaltung wählen'}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        objectKind={ObjectKind.event}
        publishKind={PublishKind.isSeminar}
        compact={'yes'}
        onlyWithoutCustomer={true}
        // ignoreDate='ignore'
        minDateFilter={true}
        // sort='desc_date'
      />
    }
    if (contentType === RightDrawerContent.selectEventForLocation) {
      return <EventList
        className='w3-margin-top'
        headline={'Veranstaltung wählen'}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        objectKind={ObjectKind.event}
        publishKind={PublishKind.isSeminar}
        compact={'yes'}
        onlyWithoutLocation={true}
        // ignoreDate='ignore'
        minDateFilter={true}
        // sort='desc_date'
      />
    }
    if (contentType === RightDrawerContent.selectSeminar) {
      return <EventList
        className='w3-margin-top'
        headline={'Vorlage wählen'}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        objectKind={ObjectKind.seminar}
        publishKind={PublishKind.isTemplate}
        compact={'yes'}
      />
    }
    if (contentType === RightDrawerContent.selectCustomer) {
      return <CustomerList
        className='w3-margin-top'
        headline={`Unternehmen wählen`}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
        options={[
          ['customerShowCityAndAddress', 'yes'],
          ['noLexware', 'yes'],
        ]}
      />
    }
    if (contentType === RightDrawerContent.selectCustomerLocation) {
      return <CustomerLocationList
        className='w3-margin-top'
        headline={`Kundenstandort wählen`}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
      />
    }
    if (contentType === RightDrawerContent.selectLocation) {
      return <LocationList
        className='w3-margin-top'
        headline={`Veranstaltungsort wählen`}
        onSelect={async (id, item) => {
          mainservice.broadcast(broadCastBackKey, {
            id: id,
            name: item.name,
          })
          setContentType(RightDrawerContent.nothing)
          props.changeOpenState(State.closed)
        }}
      />
    }
    if (contentType === RightDrawerContent.editMaterial) {
      return <>
        <MaterialView
          materialItem={materialItem}
          displayMode={DisplayMode.edit}
          parentPublishKind={materialItem.publishKind}
          parentObjectKind={materialItem.objectKind}
          id={id}
        />
      </>
    }
    if (contentType === RightDrawerContent.viewMaterial) {
      return <>
        <MaterialView
          materialItem={materialItem}
          displayMode={DisplayMode.view}
          parentPublishKind={materialItem.publishKind}
          parentObjectKind={materialItem.objectKind}
          id={id}
        />
      </>
    }
    return null
  }
  const specialContent = showContent()
  if (specialContent !== null) {
    return <>
      <div>
        <button
          className='w3-button floatRight'
          onClick={() => {
            if (props.standardState !== undefined) {
              props.changeOpenState(props.standardState)
            } else if (contentType === RightDrawerContent.viewMaterial || contentType === RightDrawerContent.selectEvent || contentType === RightDrawerContent.selectSeminar) {
              // maybe obsolete?
              props.changeOpenState(State.closed)
            }
            setContentType(RightDrawerContent.nothing)
          }}
        ><X /></button>
      </div>
      {specialContent}
    </>
  }
  if (props.children) {
    return <>{props.children}</>
  }
  return null;
}
